<script>
import IconShipping from "@/components/molecules/icon-shipping";

export default {
  name: "ModeDeLivraisonOverview",
  components: { IconShipping },
  props: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<template>
  <div>
    <p class="u-font-700 u-font-19 u-font-secondary u-mb-md">
      Mon mode de livraison
    </p>
    <div class="u-flex">
      <div>
        <IconShipping
          type="PRP"
          variant="primary"
          size="sm"
        />
      </div>
      <div class="u-pl-sm">
        <div class="u-flex u-flex-align-center u-mb-md">
          <p class="u-pr-sm">
            Retrait chez un commerçant
          </p>
        </div>
        <div>
          <p class="u-mb-sm u-font-15 u-font-500">
            Le Lafayette
          </p>
          <p>
            14 Route d’Arras
          </p>
          <p>
            62160 Aix-Noulette
          </p>
          <p class="u-mb-sm">
            03 21 72 54 96
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
